import React from 'react'
import { motion } from 'framer-motion';
import LeftBanner from './LeftBanner';
import RightBanner from './RightBanner';
const Banner = () => {
  return (
    <section
      id="home"
      className="w-full relative pt-10 pb-20 flex flex-col gap-16 xl:gap-0 lgl:flex-row items-center font-titleFont"
    >
      <div className="heroGrid absolute inset-0 -z-0 pointer-events-none"></div>
      {/* slow drifting aurora blobs */}
      <motion.div
        aria-hidden
        animate={{ x: [0, 60, -20, 0], y: [0, -40, 30, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
        className="pointer-events-none absolute top-10 left-1/3 w-[420px] h-[420px] rounded-full bg-designColor/10 blur-[100px]"
      />
      <motion.div
        aria-hidden
        animate={{ x: [0, -50, 30, 0], y: [0, 40, -20, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
        className="pointer-events-none absolute bottom-0 right-10 w-[380px] h-[380px] rounded-full bg-[#ff8a5c]/10 blur-[100px]"
      />
      <LeftBanner />
      <RightBanner />
    </section>
  );
}

export default Banner
